import React from 'react';
import './App.css';
import VideoRecorder from './video';

function App() {
  return (
    <div className="App">
     <VideoRecorder/>
    </div>
  );
}

export default App;
